import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row, UncontrolledTooltip } from 'reactstrap';
import withRouter from '../../components/withRouter';
import TableContainer from '../../components/TableContainerReactTable';
import { getSites } from '../../api/siteApi';
import { Site } from '../../types/site';
import { useProfile } from '../../hooks/UserHooks';
import AddEditSiteModal from './AddEditSiteModal';

const Index = (props: any) => {
    const { userProfile } = useProfile();
    const [data, setData] = useState<Site[]>([]);
    const [dataToEdit, setDataToEdit] = useState<Site|null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isAddEditModalOpen, setIsAddEditModalOpen] = useState<boolean>(false);

    useEffect(() => {
        // Lista os publishers cadastrados na tabela
        getSites().then((res) => {
            setData(res);

        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleUpdateData = (newData: Site) => {
        const updatedData = data.map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        setData(updatedData);
    };

    const handleAddData = (newData: Site) => {
        setData([...data, newData]);
    };

    const toggleAddEditModal = () => {
        setIsAddEditModalOpen(!isAddEditModalOpen);
    };

    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'shortOffset',
    };

    const columns = [
        {
            header: '#',
            cell: (cell: any) => {
                return (
                    <span className="fw-semibold">{cell.getValue()}</span>
                );
            },
            accessorKey: 'id',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Media Cad',
            accessorKey: 'mediaCad',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Site',
            accessorKey: 'site',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'App',
            accessorKey: 'app',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'TAGs',
            accessorKey: "tags.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Placements',
            accessorKey: "placements.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        
        {
            header: 'Pedidos',
            accessorKey: "orders.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Criado em",
            accessorFn: (row: any) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Atualizado em",
            accessorFn: (row: any) => {
                const date = new Date(row.updatedAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Actions',
            cell: (cell: any) => {
                const row = cell.row.original;
                let actionCell = [];

                // Botão personificar
                if (userProfile && userProfile.role === 'ROLE_SUPER_ADMIN') {
                    // Botão de editar
                    actionCell.push(<div key="action_edit">
                        <button className="btn text-primary d-inline-block"
                                id={'action_edit_' + row.id}
                                onClick={() => {
                                    setDataToEdit(row);
                                    toggleAddEditModal();
                                }}
                        ><i className="ri-pencil-fill fs-16"></i></button>
                        <UncontrolledTooltip
                            placement="top"
                            target={'action_edit_' + row.id}
                        >
                            Editar
                        </UncontrolledTooltip>
                    </div>);
                }
                return <div className="d-flex gap-2">{actionCell}</div>;
            },
            enableColumnFilter: false,
        },
    ];

    document.title = 'Ad Network | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <h5 className="card-title mb-0">Sites</h5>
                                        </div>
                                        <div className="col-sm-auto">
                                            <button
                                                type="button"
                                                className="btn btn-success add-btn me-1"
                                                id="create-btn"
                                                onClick={() => {
                                                    setDataToEdit(null);
                                                    toggleAddEditModal();
                                                }}
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Adicionar site
                                            </button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                     {!loading ? <TableContainer
                                                divClass="table-responsive"
                                                columns={(columns || [])}
                                                data={(data || [])}
                                                isGlobalFilter={true}
                                                customPageSize={30}
                                                SearchPlaceholder="Procurar..."
                                            /> :
                                         <div className="text-center">
                                             <div className="spinner-border text-primary" role="status">
                                                 <span className="visually-hidden">Carregando...</span>
                                             </div>
                                         </div>}

                                    <AddEditSiteModal
                                        site={dataToEdit}
                                        isOpen={isAddEditModalOpen}
                                        toggle={toggleAddEditModal}
                                        onAddData={handleAddData}
                                        onUpdateData={handleUpdateData}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);